import { gsap } from 'gsap';
function Animate(Sprite, { duration = 3, ScalingFactor = 1.02, ease = 'linear', sceneStartTime }) {
  var actualwidth = Sprite.width;
  Sprite.scale.x = Sprite.scale.x * ScalingFactor;
  Sprite.scale.y = Sprite.scale.y * ScalingFactor;
  let initialx = Sprite.x;
  var animation = gsap.to(Sprite, {
    pixi: { x: actualwidth - Sprite.width + initialx },
    duration: duration,
    ease: ease,
    paused: true,
  });
  if (sceneStartTime) {
    animation.progress(sceneStartTime / duration);
  }
  return animation;
}
export default { Animate };
